import React, { useCallback } from 'react'
import useConfigureAndSendTag from '../../analytics/useConfigureAndSendTag'
import Marker from '../../map/markers/Marker'
import ArrivalMarkerHTML from './ArrivalMarkerHTML'
import { useAction } from '../../utils/react-redux'
import { setArrivalFromPoint } from '../../../store/itinerary/itinerary.actions'

import { TAG_DRAG_AND_DROP } from '../../analytics/analytics.tagids.constants'
import { ACTION } from '../../analytics/ClickTagsService'
import analyticsConstants from '../../analytics/analytics.constants'

export default function ArrivalMarker({ coords: { lng, lat } }) {
  const execSetArrivalFromPoint = useAction(setArrivalFromPoint)
  const configureAndSendTag = useConfigureAndSendTag()

  const onDragEnd = useCallback(event => {
    const position = event?.target?._lngLat

    if (!position) return

    execSetArrivalFromPoint(position)
    configureAndSendTag({
      type: TAG_DRAG_AND_DROP,
      tagInfo: { [ACTION]: analyticsConstants.itinerary.dragndrop.action.arrival }
    })
  }, [])

  return (
    <Marker
      key={`${lng}_${lat}`}
      coordinates={{ lng, lat }}
      anchorPosition="bottom"
      dragOptions={{
        onDragEnd
      }}
    >
      <ArrivalMarkerHTML />
    </Marker>
  )
}
